"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var WaterTaxi = function WaterTaxi(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.75,20.367a3.947,3.947,0,0,0,3.76,2.882,3.947,3.947,0,0,0,3.637-3.036,3.947,3.947,0,0,0,3.76,2.882,3.947,3.947,0,0,0,3.637-3.035,3.95,3.95,0,0,0,3.761,2.882,3.95,3.95,0,0,0,3.637-3.036",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.418,18.811c-1.495-.709-2.3-3.653-1.587-5.148,4.454.648,17.075,2.606,17.075,2.606l.786,2.2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.818 13.957L8.641 8.362",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.461,15.582l.366-1.6a1.479,1.479,0,0,1,1.655-1.135l1.516.22a1.479,1.479,0,0,1,1.23,1.793l-.322,1.412",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.890 9.750 A2.220 2.220 0 1 0 15.330 9.750 A2.220 2.220 0 1 0 10.890 9.750 Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.789 1.042L18.843 0.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.85 4.001L15.946 3.77",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }));
};
WaterTaxi.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
WaterTaxi.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = WaterTaxi;